const development_tenant = {
    notification: 'Jsi v režimu vývoje',
};
export default Object.freeze(development_tenant);
